import { FC } from 'react';

import { Box } from '@mui/material';

import { ReactComponent as ChevronLeftIcon } from 'assets/icons/ChevronLeft.svg';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/ChevronRight.svg';

import { useChangeSections } from 'hooks/useChangeSections';

import { Button } from 'components/_basic/Button/Button';

import styles from './BottomNavigationButtonsMobile.module.scss';

export const BottomNavigationButtonsMobile: FC = () => {
  const { setNextSubSection, setPrevSubSection } = useChangeSections();
  const onClickNext = () => {
    document.querySelector('[class^="BaseLayout"]')?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    setNextSubSection();
  };

  return (
    <Box className={styles.wrapper}>
      <Button
        className={styles.button}
        variant="text"
        color="info"
        startIcon={<ChevronLeftIcon />}
        onClick={setPrevSubSection}
      >
        Previous
      </Button>
      <Button
        className={styles.button}
        variant="text"
        color="info"
        endIcon={<ChevronRightIcon />}
        onClick={onClickNext}
      >
        Next
      </Button>
    </Box>
  );
};
